import * as statuses from '../constants/gigStatuses';

export function isGigPaused(gigStatus, traffiqed = false) {
    return gigStatus === statuses.SUSPENDED || gigStatus === statuses.ONHOLD || traffiqed;
}

export function isGigApproved(gigStatus) {
    return gigStatus === statuses.APPROVED;
}
